import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import cartReducer from "./slices/cart-slice";
import compareReducer from "./slices/compare-slice";
import currencyReducer from "./slices/currency-slice";
import { filtersSlice } from "./slices/filters-slice";
import productReducer from "./slices/product-slice";
import wishlistReducer from "./slices/wishlist-slice";
import { productsFiltersListeners } from "./listeners/products-filters-listeners";

const persistConfig = {
  key: "airomnishop",
  version: 1.1,
  storage,
  blacklist: ["product"],
};

export const rootReducer = combineReducers({
  product: productReducer,
  currency: currencyReducer,
  cart: cartReducer,
  compare: compareReducer,
  wishlist: wishlistReducer,
  [filtersSlice.name]: filtersSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(productsFiltersListeners.middleware),
  devTools: true,
});

export const persistor = persistStore(store);
